<template>
  <div class="mb-4 flex items-start" data-cy="chat-typing-indicator">
    <div class="mr-2 flex h-8 w-8 items-center justify-center rounded-full bg-gray-800 text-white">
      <chat-icon :width="12" :height="12" />
    </div>
    <div class="rounded-lg bg-gray-100 px-4 py-3">
      <div class="flex space-x-2">
        <div class="h-2 w-2 animate-bounce rounded-full bg-gray-400"></div>
        <div
          class="h-2 w-2 animate-bounce rounded-full bg-gray-400"
          style="animation-delay: 0.2s"
        ></div>
        <div
          class="h-2 w-2 animate-bounce rounded-full bg-gray-400"
          style="animation-delay: 0.4s"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatIcon from "@/components/icons/IconChat.vue";
</script>
